import { BasicClient } from '@/utils/httpClient'

export default class Search {
  client

  constructor() {
    this.client = new BasicClient()
  }
  searchEmployees(limit, page, params) {
    const paginado = `?pagination=${limit},${page},0`
    return this.client.exec(
      `/OnBoarding/UserOnBoarding${paginado}`,
      'GET',
      params
    )
  }
  searchSector() {
    return this.client.exec('/users/retrieveSector', 'GET')
  }
  searchLocacion() {
    return this.client.exec('/users/retrieveLocation', 'GET')
  }
  Aprove(id) {
    return this.client.exec('/OnBoarding/AproveOnBoarding', 'POST', {
      iduser: id
    })
  }
  SearchEforms(entity, filters) {
    return this.client.exec('/search/documento', 'POST', {
      entity,
      filters
    })
  }
  SearchUsuario(entity, filters) {
    return this.client.exec(`/search/${entity}`, 'POST', { filters })
  }
  SearchEmployee(filter) {
    return this.client.exec('/v2/admin-mod/users/search', 'GET', { filter })
  }
  SearchDocuments(filters, params) {
    return this.client.exec(
      `/v2/admin-mod/documents/search?${params}`,
      'POST',
      filters
    )
  }
  DownloadZip(documentsId) {
    return this.client.downloadFile(
      '/v2/admin-mod/documents/downloadFilesAsZip',
      {
        documentsId
      }
    )
  }
  DownloadExcel(filters, params) {
    return this.client.downloadFile(
      `/v2/admin-mod/documents/download?${params}`,
      filters
    )
  }
  ResultEforms(filters) {
    return this.client.exec(
      '/v2/admin-mod/documents/filtersEforms',
      'POST',
      filters
    )
  }
  DownloadMetadata(eformExport) {
    return this.client.downloadFile(
      `/v2/admin-mod/documents/downloadMetadata`,
      { eformExport }
    )
  }
  SearchEmployeesToReport(params) {
    return this.client.exec(`/v2/admin-mod/users/reportto?${params}`, 'GET')
  }
}
